import { render, staticRenderFns } from "./active.vue?vue&type=template&id=4fe3724b&scoped=true"
import script from "./active.vue?vue&type=script&lang=js"
export * from "./active.vue?vue&type=script&lang=js"
import style0 from "./active.vue?vue&type=style&index=0&id=4fe3724b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe3724b",
  null
  
)

export default component.exports